import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import Markdown from 'react-markdown';
import rehypeAttrs from 'rehype-attr';
import rehypeRaw from 'rehype-raw';
import rehypeUnwrapImages from 'rehype-unwrap-images';
import { useNavigate, useParams } from 'react-router-dom';
import { DATE_NOW, PUBLIC_URL, ROUTES } from '../../lib/constants';
import styles from './BlogArticle.module.scss';
import { Banner } from '../../components/Banner/Banner';
import { Image } from '../../components/Image/Image';


export const BlogArticle = (): React.JSX.Element => {
  const navigate = useNavigate();
  const [content, setContent] = useState<string>();
  const [title, setTitle] = useState<string>();
  const { id } = useParams();
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const loadMarkdown = async () => {
      const resp = await fetch(`${PUBLIC_URL}blogs/article-${id}.md?ts=${DATE_NOW}`);
      const result = await resp.text();
      if (result.startsWith('#')) {
        setContent(result);
      } else {
        navigate(`/blog/article/${id}/404`);
      }
    };
    loadMarkdown();
  }, [ id, navigate ])

  useEffect(() => {
    if (content) {
      setTimeout(() => {
        const textContent = document.querySelector('h1')?.textContent;
        if (textContent) setTitle(textContent);
        const citeEls = Array.from(document.querySelectorAll('.cite'));
        if (citeEls.length) {
          const cite = document.createElement('cite');
          cite.append(...citeEls);
          ref.current?.appendChild(cite);
        }
      }, 20);
    }
  }, [ content, ref ])

  return (
    <>
    {
      !!title &&
      <Helmet>
        <title>{ROUTES.blogArticle.title} - {title}</title>
      </Helmet>
    }
      <section className={styles.article}>
        <div className={styles.designElement}></div>
        <div className='grid-12'>
          <div ref={ref} className={styles.container}>
            <Markdown
              rehypePlugins={[
                [rehypeUnwrapImages, { fragment: true }],
                rehypeRaw,
                [rehypeAttrs, { properties: 'attr' }],
              ]}
              components={{
                img(props) {
                  // eslint-disable-next-line
                  const { node, children, src, alt, ...rest} = props;
                  return <Image src={`${PUBLIC_URL}blogs/${src}`} alt={alt} {...rest}/>
                },
                hr: () => <div className='separator'></div>,
                code: 'cite',
              }}
            >
              { content }
            </Markdown>
          </div>
        </div>
        <Banner
          headline='Ready to make the switch?'
          text='Let&rsquo;s get you signed up today!'
          btnText='View Internet Packages'
          btnLink={ROUTES.gigInternet.path}
        />
      </section>
    </>


  )
}